"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.TabContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.TabContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .tab-title {\n    color: ", ";\n  }\n"], ["\n  .tab-title {\n    color: ",
    ";\n  }\n"])), function (props) {
    return props.theme.colors ? props.theme.colors.title : '#404040';
});
exports.Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 15px;\n  flex-grow: 1;\n\n  .MuiPaper-root {\n    background: transparent;\n    box-shadow: none;\n  }\n"], ["\n  background: ",
    ";\n  border-radius: 15px;\n  flex-grow: 1;\n\n  .MuiPaper-root {\n    background: transparent;\n    box-shadow: none;\n  }\n"])), function (props) {
    return props.theme.colors ? props.theme.colors.background : '#fff';
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map